import React, {Component, Fragment} from 'react';
import LoginPage from "./LoginPage";
import MainPage from "./MainPage";

class RemotePage extends Component {
    constructor(props) {
        super(props);
    };
    state = {
        isLogin: false,
    };

    componentDidMount() {
    }

    login = () => {
        this.setState({
            isLogin: true,
        })
    }

    logout = () => {
        this.setState({
            isLogin: false,
        })
    }
    render() {
        const { isLogin } = this.state
        const { login, logout } = this;
        return (
            <Fragment>
                {isLogin ?
                    <Fragment>
                        <MainPage
                            logout={logout}
                            />
                    </Fragment>
                :
                    <Fragment>
                        <LoginPage
                            login={login}
                        />
                    </Fragment>
                }

            </Fragment>
        )
    }

}

export default RemotePage;